import JSZip from "jszip";
import ApiAvisRPORepository from "@/repositories/ApiAvisRPORepository";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  formatDate(timestamp) {
    let date = new Date(timestamp);
    return date.toLocaleDateString();
  },
  etat: {
    /*
+----+-------------------------+
| id | libelle                 |
+----+-------------------------+
|  1 | Brouillon               |
|  2 | Examen administratif    |
|  3 | En attente d'avis       |
|  4 | Examen CRA              |
|  5 | Agrément validé         |
|  6 | Agrément refusé         |
|  7 | Agrément expiré         |
|  8 | Bloqué                  |
+----+-------------------------+
    */
    BROUILLON: { id: 1, libelle: "Brouillon" },
    EXAMEN_ADMINISTRATIF: { id: 2, libelle: "Examen administratif" },
    ATTENTE: { id: 3, libelle: "En attente d'avis" },
    EXAMEN_CRA: { id: 4, libelle: "Examen CRA" },
    VALIDÉ: { id: 5, libelle: "Agrément validé" },
    REFUSÉ: { id: 6, libelle: "Agrément refusé" },
    EXPIRÉ: { id: 7, libelle: "Agrément expiré" },
    BLOQUÉ: { id: 8, libelle: "Bloqué" }
  },
  REFRESH_TIMER: parseInt(process.env.VUE_APP_RESUME_DOSSIER_REFRESH_TIMER),
  getLibelleEtatById(id) {
    let etat = this.etat.find(e => e.id === id);
    if (etat && etat.libelle) return etat.libelle;
    return "Etat inconnu";
  },
  isBrouillon(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.BROUILLON.id;
  },
  isExamenAdministratif(dossier) {
    return (
      dossier.etat && dossier.etat.id === this.etat.EXAMEN_ADMINISTRATIF.id
    );
  },
  isAttente(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.ATTENTE.id;
  },
  isExamenCRA(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.EXAMEN_CRA.id;
  },
  isFinalise(dossier) {
    return dossier.dateDecisionCRA;
  },
  isValide(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.VALIDÉ.id;
  },
  isRefuse(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.REFUSÉ.id;
  },
  isExpire(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.EXPIRÉ.id;
  },
  isBloque(dossier) {
    return dossier.etat && dossier.etat.id === this.etat.BLOQUÉ.id;
  },
  getAvisLibelle(avis) {
    if (null === avis) return "Pas d'avis";
    if (avis) return "Favorable";
    else return "Défavorable";
  },
  getAvisCROPSelectData() {
    return this.getAvisSelectData();
  },
  getAvisRPOSelectData() {
    return this.getAvisSelectData();
  },
  getAvisSelectData() {
    return [
      { value: 2, text: "Pas d'avis" },
      { value: true, text: "Favorable" },
      { value: false, text: "Défavorable" }
    ];
  },
  getVisiteProgrammeeSelectData() {
    return this.getVisiteSelectData();
  },
  getVisiteEffectueeSelectData() {
    return this.getVisiteSelectData();
  },
  getVisiteSelectData() {
    return [
      { value: true, text: "Oui" },
      { value: false, text: "Non" }
    ];
  },
  hasVisiteProgrammee(dossier) {
    if (
      dossier &&
      dossier.avisRPO &&
      dossier.avisRPO.visite &&
      dossier.avisRPO.visite.dateLimite
    )
      return true;
    return false;
  },
  hasVisiteEffectuee(dossier) {
    if (
      dossier &&
      dossier.avisRPO &&
      dossier.avisRPO.visite &&
      dossier.avisRPO.visite.dateCR
    ) {
      return true;
    }
    return false;
  },
  getPDFURL(dossier, code = null) {
    return ApiDossierRepository.getPDFURL(dossier.id, code);
  },
  getJustificatifURL(justificatif) {
    if (justificatif.id)
      return ApiDossierRepository.getJustificatifURL(justificatif.id);
    return false;
  },
  async telechargerDossier(dossier) {
    const pdf = await ApiDossierRepository.getPDF(dossier.id);
    return pdf;
  },
  sendMailInscription(dossier) {
    return ApiDossierRepository.sendMailInscription(dossier.id);
  },
  async setEtatAttente(dossier) {
    return await ApiDossierRepository.setEtatAttente(dossier.id);
  },
  async setEtatExamenCRA(dossier) {
    return await ApiDossierRepository.setEtatExamenCRA(dossier.id);
  },
  async setEtatBrouillon(dossier, parameters = null) {
    return await ApiDossierRepository.setEtatBrouillon(
      dossier.id,
      parameters ? parameters : {}
    );
  },
  async setEtatValide(dossier) {
    return await ApiDossierRepository.setEtatValide(dossier.id, dossier);
  },
  async setEtatRefuse(dossier) {
    return await ApiDossierRepository.setEtatRefuse(dossier.id, dossier);
  },
  async deleteDossier(dossier) {
    return await ApiDossierRepository.delete(dossier.id);
  },
  async initAvisRPO(dossier, avis) {
    if (dossier.avisRPO) {
      avis = await ApiAvisRPORepository.get(dossier.avisRPO.id);
      if (avis.visite) avis.visite.fichierCR = null;
      else {
        avis.visite = {
          commentaire: null,
          dateCR: null,
          dateLimite: null,
          fichierCR: null,
          cuNom: null,
          cuPrenom: null,
          cuEmail: null,
          cuTel: null,
          coNom: null,
          coPrenom: null,
          coEmail: null,
          coTel: null,
          additionalMails: []
        };
      }
      return avis;
    }
    return {
      avis: null,
      visite: {
        commentaire: null,
        dateCR: null,
        dateLimite: null,
        fichierCR: null,
        cuNom: null,
        cuPrenom: null,
        cuEmail: null,
        cuTel: null,
        coNom: null,
        coPrenom: null,
        coEmail: null,
        coTel: null,
        additionalMails: []
      },
      date: null,
      etat: false,
      id: null
    };
  },
  dossiertoCSV(dossier) {
    let csvLine =
      '"' +
      dossier.officine.denomination +
      " (" +
      dossier.officine.codePostal +
      " " +
      dossier.officine.ville +
      ')";';
    csvLine = csvLine + '"' + dossier.demandeur + '";';
    csvLine = csvLine + '"' + this.formatDate(dossier.dateDepot) + '";';
    csvLine =
      csvLine +
      '"' +
      (dossier.premiereDemande ? "Première demande" : "Renouvellement") +
      '";';
    csvLine =
      csvLine +
      '"' +
      (dossier.stagiairesFormes
        ? "Oui (" + dossier.stagiairesFormes + ")"
        : "Non") +
      '";';
    csvLine =
      csvLine +
      '"' +
      (dossier.avisCROP.avis ? "Favorable" : "Défavorable") +
      '";';
    csvLine =
      csvLine +
      '"' +
      (dossier.avisRPO.avis ? "Favorable" : "Défavorable") +
      '"\n';
    return csvLine;
  },
  toCSVSummary(dossiers, inline = true) {
    let csv = "";
    if (inline) csv += "data:text/csv;charset=utf-8,";
    csv +=
      '"Établissement";"Demandeur";"Date de dépot";"Statut";"Accueil de stagiaire sur les 5 dernières années";"Avis CROP";"Avis RPO"\n';
    for (const dossier of dossiers.filter(d => this.isExamenCRA(d))) {
      csv += this.dossiertoCSV(dossier);
    }
    return csv;
  },
  dossierFinalisetoCSV(dossier) {
    let csvLine = '"' + dossier.maitrePrenom + " " + dossier.maitreNom + '";';
    csvLine += '"' + dossier.officine.denomination + '";';
    csvLine += '"' + dossier.officine.adresse + '";';
    csvLine += '"' + dossier.officine.codePostal + '";';
    csvLine += '"' + dossier.officine.ville + '";';
    csvLine += '"' + dossier.officine.tel + '";';
    csvLine += '"' + (dossier.decisionCRA ? "oui" : "non") + '";';
    const date = new Date(dossier.dateDecisionCRA);
    let dateAgrement =
      date.getDate() +
      "/" +
      this.pad(date.getMonth() + 1) +
      "/" +
      date.getFullYear();
    csvLine += '"' + dateAgrement + '"';
    csvLine += "\n";
    return csvLine;
  },
  pad(s) {
    return s <= 9 ? "0" + s : "" + s;
  },
  getCSVDossiersFinalises(dossiers) {
    let csv = "data:text/csv;charset=utf-8,";
    csv +=
      '"Pharmacien";"Officine - denomination";"Officine - adresse";"Officine - code postal";"Officine - ville";"Officine - téléphone";"Agrément";"Date de debut de l\'agrément"\n';
    for (const dossier of dossiers.filter(d => this.isFinalise(d))) {
      csv += this.dossierFinalisetoCSV(dossier);
    }
    return csv;
  },
  async dossiersToZip(dossiers, progress) {
    if (dossiers && Array.isArray(dossiers) && dossiers.length) {
      const dossiersCRA = dossiers.filter(d => this.isExamenCRA(d));
      progress.avancement = 0;
      let i = 0;
      const max = dossiersCRA.length;
      let zip = new JSZip();
      progress.fichier = "tableauCRA.csv";
      zip = zip.file("tableauCRA.csv", this.toCSVSummary(dossiers, false));
      for (let dossier of dossiersCRA) {
        const officineDirectory =
          dossier.officine.denomination +
          "-" +
          dossier.officine.codePostal +
          "-" +
          dossier.officine.ville;
        progress.avancement = (100 * i++) / max;
        progress.fichier = officineDirectory + "/dossier.pdf";
        const pdf = await ApiDossierRepository.getPDF(dossier.id);
        zip.file(officineDirectory + "/dossier.pdf", pdf);
        //Ajouter les justificatifs
        const justificatifs = await ApiDossierRepository.getJustificatifs(
          dossier.id
        );
        if (
          justificatifs &&
          Array.isArray(justificatifs) &&
          justificatifs.length
        ) {
          for (const justificatif of justificatifs) {
            const file = await ApiDossierRepository.getJustificatif(
              justificatif.id
            );
            progress.fichier = officineDirectory + justificatif.name;
            zip.file(officineDirectory + "/" + justificatif.name, file);
          }
        }
        //Ajouter le compte-rendu de visite, le cas échéant
        if (
          dossier.avisRPO &&
          dossier.avisRPO.visite &&
          dossier.avisRPO.visite.dateCR
        ) {
          const avisRPO = await ApiAvisRPORepository.get(dossier.avisRPO.id);
          progress.fichier =
            officineDirectory + "/CRV-" + avisRPO.visite.compteRendu.name;
          const cr_blob = await ApiAvisRPORepository.getCR(avisRPO.id);
          zip.file(
            officineDirectory + "/CRV-" + avisRPO.visite.compteRendu.name,
            cr_blob
          );
        }
      }
      const blob = await zip.generateAsync({ type: "blob" });
      progress.avancement = 100;
      return blob;
    }
    return null;
  },
  matchDate(dossier, after, before) {
    if (after && dossier.dateDepot < after) return false;
    if (before && dossier.dateDepot > before) return false;
    return true;
  },
  isEmailValid(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
};
